import { ET_TIMEZONE } from "constants/Constants"
import { convertToTimeZone } from "date-fns-timezone"

// Use this function to get the current time in EST

// The ITSM page should align with the EST time,
// so use the date returned by this function as current date all over ITSM
export default function () {
  return new Date(convertToTimeZone(new Date(), { timeZone: ET_TIMEZONE }))
}
